export const BATCH_CREATE_3P_YARDS_SUCCESS = "BATCH_CREATE_3P_YARDS_SUCCESS";
